import React, {useMemo, useCallback} from 'react';
import {Button, CircularProgress, Stack, Typography} from '@mui/material';
import SkeletonWrap from './SkeletonWrap.js';

const SCButton = React.forwardRef((props, ref)=>{
    let {
        loading,
        size='medium',
        onClick: _onClick,
        children,
        icon,
        iconPlacement='left',
        className,
        text,
        skeleton,
        ...rest
    } = props;
    let iconSize = useMemo(()=>({small: 14, medium: 20, large: 24})[size], [size]);
    let onClick = useCallback(ev=>!loading&&_onClick?.(ev), [loading, _onClick]);
    return <SkeletonWrap skeleton={skeleton}>
      <Button
        ref={ref}
        className={className}
        size={size}
        onClick={onClick}
        {...rest}>
        <Stack direction="row" justifyContent="center" alignItems="center" gap={1}>
          {iconPlacement=='left'&&!loading&&icon}
          {loading ? <CircularProgress
            size={iconSize}
            sx={{color: 'inherit'}}
          /> : <Typography variant={size=='small' ? 'body2' : null} sx={{whiteSpace: 'nowrap'}}>
            {text||children}
          </Typography>}
          {iconPlacement=='right'&&!loading&&icon}
        </Stack>
      </Button>
    </SkeletonWrap>;
});

export default SCButton;
